import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {shallowEqual, useSelector} from 'react-redux';
import {Button} from '@nl/component';
import {useI18n} from '@nl/i18n';
import {Link} from '@nl/core';
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';

function FreeSamplePreview(props) {
	const [showMessage, setShowMessage] = useState(false);
	const {value, text, minutes} = props;
	const [time, title, desc, subscribe, cancel] = useI18n(['time', 'title', 'desc', 'subscribe_button', 'cancel_button'], {
		keyPrefix: 'freesample_notice_',
	});
	const {WATCH_SITE_PREFIX} = useSelector((state) => state.config.data, shallowEqual);
	const {pathname} = useLocation();

	useEffect(() => {
		setShowMessage(false);
	}, [pathname]);

	return (
			<div className="free-sample-preview">
				<div className={`subscribe-message ${showMessage ? 'is-show' : ''}`}>
					<div className="remain-title">
						<span>{time}</span>
						<span className="time-num">{text}</span>
						<span className="circle-icon">
										<CircularProgressbar value={value}
																				 styles={buildStyles({
																					 pathTransition: 'none',
																					 pathColor: '#1d428a',
																					 strokeLinecap: 'butt',
																					 trailColor: '#d8dfec',
																					 rotation: (1 - value / 100),
																				 })} />
						</span>
					</div>
					<div className="subscribe--title">
						{title.replace('{0}', minutes)}
					</div>
					<div className="subscribe--desc">{desc.replace('{0}', minutes)}</div>
					<Link to={`${WATCH_SITE_PREFIX}streaming-subscriptions`}>
						<Button className="subscribe--button">{subscribe}</Button>
					</Link>
					<div className="cancel--desc">{cancel}</div>
				</div>
				<div className={`countdown ${showMessage ? 'is-show' : ''}`}
						 onClick={() => setShowMessage(!showMessage)}>
					<div className="countdown--progress">
						<CircularProgressbar value={value}
																 text={text}
																 strokeWidth={8}
																 background
																 styles={buildStyles({
																	 pathTransition: 'none',
																	 backgroundColor: 'transparent',
																	 trailColor: '#d8dfec',
																	 textColor: '#fff',
																	 pathColor: '#1d428a',
																	 strokeLinecap: 'butt',
																	 textSize: '26px',
																	 rotation: (1 - value / 100),
																 })} />
					</div>
					<div className="countdown--mask">
						<i className="close--button" />
					</div>
				</div>
			</div>
	);
}

FreeSamplePreview.defaultProps = {
	value: 0,
	text: '',
	minutes: 0,
};

FreeSamplePreview.propTypes = {
	value: PropTypes.number,
	text: PropTypes.string,
	minutes: PropTypes.number,
};

export default FreeSamplePreview;
